import { useEffect, useState } from 'react';
import {
	PAGE_LEVEL_SCRIPT_CONFIG_CDN,
	PAGE_LEVEL_SCRIPT_CONFIG_MODES
} from '../../../../../../../core/constants';
import Table from '@mui/material/Table';
import Typography from '@mui/material/Typography';
import Label from '../../../../../../../Components/Label';

import {
	TableRow,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	Paper,
	TableContainer,
	Box
} from '@mui/material';
import Button from '@mui/material/Button';

import { ToastContainer } from 'react-toastify';
import useStyles from './styles';
import { stringToSha256 } from '../../../../../../../utilities/helpers';

const SiteWisePageLevelConfigView = ({
	pageLevelScriptConfigMode,
	pageLevelScriptConfig,
	handlePageLevelScriptConfigSinglePageSync,
	handlePageLevelScriptConfigBulkPageSync,
	siteId,
	setPageLevelScriptConfigMode,
	setPageLevelScriptConfigPage
}) => {
	const classes = useStyles();
	const [tablePage, setTablePage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const headRow = ['Page Url', 'Section Level Split', 'Sync', 'CDN Url', 'Edit'];
	const contentRows = pageLevelScriptConfig.map((page) => ({
		url: page.pageUrl,
		config: page.pageLevelScriptConfig
	}));

	const handleChangePage = (event, newPage) => {
		setTablePage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setTablePage(0);
	};

	const handleUpdateConfigButtonClick = () => {
		if (
			pageLevelScriptConfigMode === PAGE_LEVEL_SCRIPT_CONFIG_MODES.SITE_LEVEL_CREATE_PAGE_CONFIGS
		) {
			setPageLevelScriptConfigMode(PAGE_LEVEL_SCRIPT_CONFIG_MODES.CREATE_PAGE_CONFIG);
		} else {
			setPageLevelScriptConfigMode(PAGE_LEVEL_SCRIPT_CONFIG_MODES.UPDATE_PAGE_CONFIG);
		}
	};
	return (
		<Box className={classes.tableWrapper}>
			<Paper style={{ padding: '3.5rem 1rem' }}>
				<Box className={classes.buttonWrapper}>
					<Button variant="contained" onClick={() => handlePageLevelScriptConfigBulkPageSync()}>
						Bulk Sync
					</Button>
					<Button variant="contained" onClick={handleUpdateConfigButtonClick}>
						Update Config
					</Button>
				</Box>
				<TableContainer>
					<Table aria-label="collapsible table">
						<TableHead>
							<TableRow>
								{headRow.map((heading, index) => {
									return (
										<TableCell key={index}>
											<Typography variant="p" fontWeight="bold" className={classes.heading}>
												{heading}
											</Typography>
										</TableCell>
									);
								})}
							</TableRow>
						</TableHead>
						<TableBody>
							{contentRows
								.slice(tablePage * rowsPerPage, tablePage * rowsPerPage + rowsPerPage)
								.map((row, index) => (
									<PageLevelScriptConfigTableRow
										key={index}
										index={index}
										siteId={siteId}
										row={row}
										handlePageLevelScriptConfigSinglePageSync={
											handlePageLevelScriptConfigSinglePageSync
										}
										setPageLevelScriptConfigPage={setPageLevelScriptConfigPage}
										setPageLevelScriptConfigMode={setPageLevelScriptConfigMode}
									/>
								))}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component="div"
					count={10}
					rowsPerPage={rowsPerPage}
					page={tablePage}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Paper>
			<ToastContainer />
		</Box>
	);
};

const PageLevelScriptConfigTableRow = (props) => {
	const {
		row,
		index,
		handlePageLevelScriptConfigSinglePageSync,
		siteId,
		setPageLevelScriptConfigPage,
		setPageLevelScriptConfigMode
	} = props;
	const [cdnUrl, setCDNUrl] = useState('');

	useEffect(() => {
		generateAndSetCDNUrl();
	}, [row, siteId]);

	const generateAndSetCDNUrl = async () => {
		try {
			const hash = await stringToSha256(row.url);
			const url = `${PAGE_LEVEL_SCRIPT_CONFIG_CDN}/instream/pageLevelConfig/${siteId}/${hash}.json`;
			setCDNUrl(url);
		} catch (error) {
			console.error('Error generating CDN URL:', error);
			setCDNUrl('');
		}
	};

	const handleEditPage = () => {
		setPageLevelScriptConfigPage(index + 1);
		setPageLevelScriptConfigMode(PAGE_LEVEL_SCRIPT_CONFIG_MODES.UPDATE_PAGE_CONFIG);
	};

	const getSectionLevelSplitString = () => {
		if (row.config.sectionLevelSplit) {
			return row.config.sectionLevelSplit.enabled ? 'Enabled' : 'Disabled';
		}
		return 'Not Available';
	};
	const sectionLevelSplitString = getSectionLevelSplitString();
	return (
		<>
			<TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
				<TableCell sx={{ maxWidth: '15rem', overflowWrap: 'break-word' }}>{row.url}</TableCell>
				<TableCell sx={{ maxWidth: '15rem', overflowWrap: 'break-word' }}>
					<Label
						variant="ghost"
						color={sectionLevelSplitString === 'Enabled' ? 'success' : 'error'}
					>
						{sectionLevelSplitString}
					</Label>
				</TableCell>

				<TableCell>
					<Button
						variant="contained"
						onClick={() => handlePageLevelScriptConfigSinglePageSync(row.url)}
					>
						Sync Page Config
					</Button>
				</TableCell>
				<TableCell>
					<a href={cdnUrl} target="_blank" rel="noreferrer">
						<Button variant="contained">CDN Url</Button>{' '}
					</a>
				</TableCell>
				<TableCell>
					<Button variant="contained" onClick={handleEditPage}>
						Edit Page
					</Button>
				</TableCell>
			</TableRow>
		</>
	);
};

export default SiteWisePageLevelConfigView;
